export default __webpack_public_path__ + "static/media/logo_text.74c77554.svg";